import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const TextFormatItalics16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M5.95806 3.50563C5.95806 3.22638 6.18348 3 6.46156 3H11.4965C11.7747 3 12 3.22638 12 3.50563C12 3.78488 11.7747 4.01126 11.4965 4.01126H9.68499L7.699 11.9887H9.53849C9.81655 11.9887 10.042 12.2152 10.042 12.4944C10.042 12.7737 9.81655 13 9.53849 13H4.5035C4.22542 13 4 12.7737 4 12.4944C4 12.2152 4.22542 11.9887 4.5035 11.9887H6.31502L8.30101 4.01126H6.46156C6.18348 4.01126 5.95806 3.78488 5.95806 3.50563Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
